import './Delivery.scss';
import Component from './Delivery.js';
export default Component;
